import React from "react";

import {Checkbox} from "@mui/material";


const PermissionCheckbox = ({accessRule, hasAccessRule, onToggle, alwaysChecked, disabled}) => {
    let checked = hasAccessRule(accessRule);

    return <Checkbox checked={alwaysChecked || checked}
                     onClick={() => onToggle(accessRule)}
                     disabled={alwaysChecked || disabled}
                     color="info"/>
}

export default PermissionCheckbox;